import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { Icon } from "@pdfking/workflow/components/Icon"
import { RootMixin } from "@pdfking/workflow/mixins/RootMixin"
import can_hover from "../features/can_hover"
import { CloseMixin } from "../mixins/Close"
import current from "../routes/current"
import navigate from "../routes/navigate"
import { SEARCH_VIEW } from "../routes/urls"
import keyboard from "../state/keyboard"
import user from "../state/user"

export const Publicsearch = CreateRenderFunction({
  computed: {
    full_placeholder() {
      return user().is_staff ? `${this.placeholder} (⌘K)` : this.placeholder
    },
    query() {
      const route = current()
      if (route.name === SEARCH_VIEW) {
        return route.props.query
      }
      return ""
    },
  },
  methods: {
    focus_search() {
      if (can_hover()) {
        ;(
          this.root?.querySelector("input.publicsearch") as HTMLInputElement
        )?.focus()
      }
    },
    keypress(event: KeyboardEvent) {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k")
        (
          this.root?.querySelector("input.publicsearch") as HTMLInputElement
        )?.focus()
    },
    searchinput(e: Event) {
      const query = (e.target as HTMLInputElement).value

      if (query) {
        navigate(SEARCH_VIEW, { query })
      } else {
        this.close()
      }
    },
    searchsubmit() {
      navigate(SEARCH_VIEW, {
        query: (
          this.root?.querySelector("input.publicsearch") as HTMLInputElement
        )?.value,
        send: 1,
      })
    },
  },
  mixins: [CloseMixin, RootMixin],
  mounted() {
    keyboard().register(this.keypress)
    document.addEventListener("focus_search", this.focus_search)
  },
  props: {
    placeholder: "",
  },
  render() {
    return (
      <form
        class="w-100 position-relative"
        onSubmit={(e: Event) => {
          e.stopPropagation()
          e.preventDefault()
          this.searchsubmit()
        }}
      >
        <input
          autocomplete="off"
          class="form-control publicsearch"
          onInput={this.searchinput}
          placeholder={this.full_placeholder}
          style="padding-left: 40px"
          type="search"
          value={this.query}
        />
        <Icon
          class="position-absolute top-50 translate-middle-y start-0 ms-3"
          name="SEARCH"
        />
      </form>
    )
  },
  unmounted() {
    document.removeEventListener("focus_search", this.focus_search)
  },
})
